import {
  getFilteredBudgets,
  hideMediaBuyerBudgetLoader,
  setMediaBuyerBudgets,
  setMediaBuyerBudgetsForId,
  showMediaBuyerBudgetLoader,
} from "./actions";
import { call, put, select, takeEvery } from "redux-saga/effects";
import {
  deleteMediaBuyerBudgets,
  getCampaignMediaBuyer,
  getMediaBuyerBudgetByBudgetId,
  getMediaBuyerBudgets,
  postMediaBuyerBudget,
  patchMediaBuyerBudget,
  getFilteredMediaBuyerBudgets,
  postMediaBuyerPlan,
} from "../../../helpers/jwt_helper";
import {
  DELETE_MEDIA_BUYER_BUDGET,
  GET_MEDIA_BUYER_BUDGETS,
  GET_MEDIA_BUYER_DATA_FOR_ADD,
  ADD_MEDIA_BUYER_BUDGET,
  GET_MEDIA_BUYER_BUDGET_FOR_ID,
  PATCH_MEDIA_BUYER_BUDGET,
  GET_FILTERED_MEDIA_BUYER_BUDGET,
  ADD_MEDIA_BUYER_BUDGET_BY_OFFER,
  DELETE_MEDIA_BUYER_BUDGET_BY_OFFER,
} from "./actionType";
import {
  getFilteredPlans,
  hidePlansDataLoader,
  setMediaBuyerDataForAdd,
  showPlansDataLoader,
} from "./actions";
import {
  showErrorMessage,
  getErrorMessage,
  showSuccessMessage,
} from "../../../helpers/utils";

function* onGetMediaBuyersBudget({ payload: data }) {
  try {
    yield put(showMediaBuyerBudgetLoader());
    let response = yield call(getMediaBuyerBudgets, {
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      client: data.client,
      search: data.search,
    });
    response = {
      ...data,
      ...response,
      results: response.results.map(i => ({
        ...i,
        created_at: new Date(i.created_at).toDateString(),
      })),
    };
    yield put(setMediaBuyerBudgets(response));
    yield put(hideMediaBuyerBudgetLoader());
  } catch (e) {
    showErrorMessage(getErrorMessage(e));
    yield put(hideMediaBuyerBudgetLoader());
  }
}

function* onFilteredBudgets({ payload: { filter, data } }) {
  try {
    yield put(showMediaBuyerBudgetLoader());
    console.log({filter, data})
    let res = yield call(getFilteredMediaBuyerBudgets, filter, data);
    yield put(setMediaBuyerBudgets(res));
    yield put(hideMediaBuyerBudgetLoader());
  } catch (e) {
    // showErrorMessage(getErrorMessage(e));
    yield put(hideMediaBuyerBudgetLoader());
  }
}

function* onPostMediaBuyerBudgetsByOffer({ payload: { budget } }) {
  try {
    let data = yield select(state => state.MediaBuyerBudgets.data);
    let post_req = {
      budget: budget.budget,
      date_range: budget.date,
      media_buyer: budget.mediaBuyer,
      offer: budget.offer,
    };
    let filter = `offer=${budget.offer}`;
    yield put(showMediaBuyerBudgetLoader());
    yield call(postMediaBuyerBudget, post_req);
    yield put(getFilteredBudgets(filter, data));
    yield put(hideMediaBuyerBudgetLoader());
    showSuccessMessage("Added media buyer plan has been successfully");
  } catch (e) {
    // showErrorMessage(getErrorMessage(e));
    yield put(hideMediaBuyerBudgetLoader());
  }
}

function* onGetMediaBuyersDataForAdd() {
  try {
    yield put(showMediaBuyerBudgetLoader());
    let campaignMediaBuyers = yield call(getCampaignMediaBuyer);
    yield put(hideMediaBuyerBudgetLoader());
    let data = {
      mediaBuyers: campaignMediaBuyers.results,
    };
    yield put(setMediaBuyerDataForAdd(data));
  } catch (e) {
    yield put(hideMediaBuyerBudgetLoader());
  }
}

function* onPostMediaBuyers({ payload: { budget, data } }) {
  try {
    let post_req = {
      budget: budget.budget,
      date_range: budget.date,
      media_buyer: budget.mediaBuyer,
      offer: budget.offer,
    };
    yield put(showMediaBuyerBudgetLoader());
    yield call(postMediaBuyerBudget, post_req);
    yield call(onGetMediaBuyersBudget, { payload: data });
    yield put(hideMediaBuyerBudgetLoader());
    showSuccessMessage("Added media buyer budget has been successfully");
  } catch (e) {
    showErrorMessage(getErrorMessage(e));
    yield put(hideMediaBuyerBudgetLoader());
  }
}

function* onGetMediaBuyerDataForId({ payload: { id } }) {
  try {
    yield put(showMediaBuyerBudgetLoader());
    let res = yield call(getMediaBuyerBudgetByBudgetId, id);
    yield put(setMediaBuyerBudgetsForId(res));
    yield put(hideMediaBuyerBudgetLoader());
  } catch (e) {
    showErrorMessage(getErrorMessage(e));
    yield put(hideMediaBuyerBudgetLoader());
  }
}

function* onPatchMediaBuyerBudget({ payload: { id, data } }) {
  try {
    yield put(showMediaBuyerBudgetLoader());
    let res = yield call(patchMediaBuyerBudget, id, data);
    yield put(hideMediaBuyerBudgetLoader());
    showSuccessMessage(
      `Updating media buyer budget ${id} has been successfully`
    );
  } catch (e) {
    showErrorMessage(getErrorMessage(e));
    yield put(hideMediaBuyerBudgetLoader());
  }
}

function* onDeleteMediaBuyerBudget({ payload: { id, data } }) {
  try {
    yield put(showMediaBuyerBudgetLoader());
    yield call(deleteMediaBuyerBudgets, id);
    yield call(onGetMediaBuyersBudget, { payload: data });
    showSuccessMessage(
      `Deleting media buyer budget ${id} has been successfully`
    );
  } catch (e) {
    yield put(hideMediaBuyerBudgetLoader());
    showErrorMessage(getErrorMessage(e));
  }
}

function* onDeleteMediaBuyerBudgetByOffer({ payload: { id, offerId } }) {
  try {
    let data = yield select(state => state.MediaBuyerBudgets.data);
    yield put(showMediaBuyerBudgetLoader());
    let filter = `offer=${offerId}`;
    yield call(deleteMediaBuyerBudgets, id);
    yield put(getFilteredBudgets(filter, data));
    showSuccessMessage(
      `Deleting media buyer budget ${id} has been successfully`
    );
  } catch (e) {
    yield put(hideMediaBuyerBudgetLoader());
    // showErrorMessage(getErrorMessage(e));
  }
}

function* mediaBuyersBudgetsSaga() {
  yield takeEvery(PATCH_MEDIA_BUYER_BUDGET, onPatchMediaBuyerBudget);
  yield takeEvery(GET_MEDIA_BUYER_BUDGET_FOR_ID, onGetMediaBuyerDataForId);
  yield takeEvery(GET_MEDIA_BUYER_BUDGETS, onGetMediaBuyersBudget);
  yield takeEvery(GET_MEDIA_BUYER_DATA_FOR_ADD, onGetMediaBuyersDataForAdd);
  yield takeEvery(DELETE_MEDIA_BUYER_BUDGET, onDeleteMediaBuyerBudget);
  yield takeEvery(ADD_MEDIA_BUYER_BUDGET, onPostMediaBuyers);
  yield takeEvery(GET_FILTERED_MEDIA_BUYER_BUDGET, onFilteredBudgets);
  yield takeEvery(
    ADD_MEDIA_BUYER_BUDGET_BY_OFFER,
    onPostMediaBuyerBudgetsByOffer
  );
  yield takeEvery(
    DELETE_MEDIA_BUYER_BUDGET_BY_OFFER,
    onDeleteMediaBuyerBudgetByOffer
  );
}

export default mediaBuyersBudgetsSaga;
